import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import PageBanner from "../components/PageBanner/PageBanner";
import Sidebar from "../components/Sidebar/Sidebar";
import { BlogPostCard } from "../components/BlogSection/BlogSection";
import bannerBg from "../assets/images/slider0.jpg";
import "./PatiHikayeleri.scss";

const SearchResultsPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q"); // URL'den 'q' parametresini al (örn: kedi)

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!query) {
      setResults([]);
      setLoading(false);
      return;
    }

    const performSearch = async () => {
      setLoading(true);
      // Az önce oluşturduğumuz özel fonksiyonu çağırıyoruz
      const { data, error } = await supabase.rpc("search_posts", {
        search_term: query,
      });

      if (error) {
        setError("Arama yapılırken bir hata oluştu.");
        console.error(error);
      } else {
        setResults(data);
      }
      setLoading(false);
    };

    performSearch();
  }, [query]); // Arama terimi her değiştiğinde bu fonksiyon yeniden çalışır

  const renderContent = () => {
    if (loading) return <p>Sonuçlar aranıyor...</p>;
    if (error) return <p>{error}</p>;
    if (results.length === 0) {
      return (
        <p>Aradığınız '{query}' kelimesiyle eşleşen bir sonuç bulunamadı.</p>
      );
    }
    return results.map((post) => (
      <BlogPostCard
        key={post.id}
        image={post.image_url}
        date={new Date(post.created_at).toLocaleDateString("tr-TR", {
          day: "numeric",
          month: "long",
        })}
        title={post.title}
        excerpt={post.excerpt}
        // Linki, yazının kategorisine göre dinamik oluşturalım
        url={`/${
          post.category === "Pati Hikayeleri"
            ? "pati-hikayeleri"
            : "hekimlerimizden"
        }/${post.slug}`}
      />
    ));
  };

  return (
    <div className="search-results-page">
      <PageBanner title={`Arama Sonuçları: '${query}'`} bgImage={bannerBg} />
      <div className="page-content-wrapper">
        <div className="blog-list-column">{renderContent()}</div>
        <div className="sidebar-column">
          <Sidebar />
        </div>
      </div>
    </div>
  );
};

export default SearchResultsPage;
